import * as React from "react";
import {ReactNode, useRef} from "react";
import SlickSlider, {Settings} from "react-slick";
import {css, Theme, useTheme} from "@emotion/react";
import {Interpolation} from "@emotion/styled";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons";

import {useWaitForFirstRender} from "../hooks/use_wait_for_first_render";
import {arrowSize, arrowWrapperSize, NavigationButton} from "./NavigationButton";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface IProps {
    children: ReactNode;
    slickArrowStyle?: Interpolation<Theme>;
    settings?: Omit<Settings, "prevArrow" | "nextArrow"> & {
        /**
         * Similar to adaptiveHeight, but it adjusts slider height to all visible slides.
         */
        adaptiveHeightByAllVisible?: boolean;
        /**
         * Similar to adaptiveHeight, but also takes into account invisible slides.
         */
        adaptiveHeightIncludingInvisible?: boolean;
    };
    onSlideVisibilityChange?: (currentSlide: number, visibleSlides: number) => void;
}

export function Slider(props: IProps) {
    const {settings, slickArrowStyle, children} = props;
    const theme = useTheme();
    const sliderWrapperRef = useRef<HTMLDivElement>(null);
    const sliderRef = useRef<SlickSlider>(null);

    const sliderSettings: Settings | undefined = settings
        ? {
              ...settings,
              arrows: true,
              prevArrow: (
                  <NavigationButton css={[slickArrowPrev, slickArrowStyle]}>
                      <ChevronLeftIcon size={arrowSize} wrapperSize={arrowWrapperSize} wrapperColor={theme.colors.primary} />
                  </NavigationButton>
              ),
              nextArrow: (
                  <NavigationButton css={[slickArrowNext, slickArrowStyle]}>
                      <ChevronRightIcon size={arrowSize} wrapperSize={arrowWrapperSize} wrapperColor={theme.colors.primary} />
                  </NavigationButton>
              )
          }
        : undefined;

    const handleSlideVisibilityChange = (currentSlide: number) => {
        if (!sliderWrapperRef.current || !sliderRef.current || settings?.vertical) {
            return;
        }

        const sliderElement = sliderWrapperRef.current;
        const totalSliderWidth = sliderElement.offsetWidth;

        const slider = sliderRef.current;
        const slideElement = slider.innerSlider?.list?.querySelector(".slick-slide");

        if (slideElement) {
            const slideWidth = slideElement.getBoundingClientRect().width;

            // Calculate visible slides
            const visibleSlides = Math.floor(totalSliderWidth / slideWidth);
            props.onSlideVisibilityChange?.(currentSlide, visibleSlides);
        }
    };

    const afterChange = (currentSlide: number) => {
        sliderSettings?.afterChange?.(currentSlide);
        handleSlideVisibilityChange(currentSlide);
    };

    useWaitForFirstRender(() => {
        // Call handleSlideVisibilityChange with the initial slide
        const initialSlide = sliderSettings?.initialSlide || 0;
        handleSlideVisibilityChange(initialSlide);
    });

    return (
        <div ref={sliderWrapperRef} css={sliderWrap}>
            <SlickSlider
                ref={sliderRef}
                {...sliderSettings}
                afterChange={afterChange}
                css={[
                    ...(settings?.adaptiveHeightByAllVisible ? [adaptiveHeightByAllVisibleStyle] : []),
                    ...(settings?.adaptiveHeightIncludingInvisible ? [adaptiveHeightIncludingInvisibleStyle] : [])
                ]}
            >
                {children}
            </SlickSlider>
        </div>
    );
}

/*
    Styles
 */

const sliderWrap = css`
    padding-bottom: ${parseFloat(arrowWrapperSize) + 4 * 0.8}rem;
`;

const slickArrowNext = css`
    right: 50%;
    transform: translate(100%, 100%);
`;

const slickArrowPrev = css`
    left: 50%;
    transform: translate(-100%, 100%);
`;

const adaptiveHeightByAllVisibleStyle = css`
    .slick-slide {
        height: 100px;
    }
    .slick-slide.slick-active {
        height: auto;
    }
`;

const adaptiveHeightIncludingInvisibleStyle = css`
    .slick-track {
        display: flex;
        align-items: stretch;
        position: relative;
    }

    .slick-slide {
        float: none;
        height: auto;
    }

    .slick-slide > * {
        height: 100%;
    }
`;
import * as React from "react";
import {ReactNode, useRef} from "react";
import SlickSlider, {Settings} from "react-slick";
import {css, Theme, useTheme} from "@emotion/react";
import {Interpolation} from "@emotion/styled";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons";

import {useWaitForFirstRender} from "../hooks/use_wait_for_first_render";
import {arrowSize, arrowWrapperSize, NavigationButton} from "./NavigationButton";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface IProps {
    children: ReactNode;
    slickArrowStyle?: Interpolation<Theme>;
    settings?: Omit<Settings, "prevArrow" | "nextArrow"> & {
        /**
         * Similar to adaptiveHeight, but it adjusts slider height to all visible slides.
         */
        adaptiveHeightByAllVisible?: boolean;
        /**
         * Similar to adaptiveHeight, but also takes into account invisible slides.
         */
        adaptiveHeightIncludingInvisible?: boolean;
    };
    onSlideVisibilityChange?: (currentSlide: number, visibleSlides: number) => void;
}

export function Slider(props: IProps) {
    const {settings, slickArrowStyle, children} = props;
    const theme = useTheme();
    const sliderWrapperRef = useRef<HTMLDivElement>(null);
    const sliderRef = useRef<SlickSlider>(null);

    const sliderSettings: Settings | undefined = settings
        ? {
              ...settings,
              arrows: true,
              prevArrow: (
                  <NavigationButton css={[slickArrowPrev, slickArrowStyle]}>
                      <ChevronLeftIcon size={arrowSize} wrapperSize={arrowWrapperSize} wrapperColor={theme.colors.primary} />
                  </NavigationButton>
              ),
              nextArrow: (
                  <NavigationButton css={[slickArrowNext, slickArrowStyle]}>
                      <ChevronRightIcon size={arrowSize} wrapperSize={arrowWrapperSize} wrapperColor={theme.colors.primary} />
                  </NavigationButton>
              )
          }
        : undefined;

    const handleSlideVisibilityChange = (currentSlide: number) => {
        if (!sliderWrapperRef.current || !sliderRef.current || settings?.vertical) {
            return;
        }

        const sliderElement = sliderWrapperRef.current;
        const totalSliderWidth = sliderElement.offsetWidth;

        const slider = sliderRef.current;
        const slideElement = slider.innerSlider?.list?.querySelector(".slick-slide");

        if (slideElement) {
            const slideWidth = slideElement.getBoundingClientRect().width;

            // Calculate visible slides
            const visibleSlides = Math.floor(totalSliderWidth / slideWidth);
            props.onSlideVisibilityChange?.(currentSlide, visibleSlides);
        }
    };

    const afterChange = (currentSlide: number) => {
        sliderSettings?.afterChange?.(currentSlide);
        handleSlideVisibilityChange(currentSlide);
    };

    useWaitForFirstRender(() => {
        // Call handleSlideVisibilityChange with the initial slide
        const initialSlide = sliderSettings?.initialSlide || 0;
        handleSlideVisibilityChange(initialSlide);
    });

    return (
        <div ref={sliderWrapperRef} css={sliderWrap}>
            <SlickSlider
                ref={sliderRef}
                {...sliderSettings}
                afterChange={afterChange}
                css={[
                    ...(settings?.adaptiveHeightByAllVisible ? [adaptiveHeightByAllVisibleStyle] : []),
                    ...(settings?.adaptiveHeightIncludingInvisible ? [adaptiveHeightIncludingInvisibleStyle] : [])
                ]}
            >
                {children}
            </SlickSlider>
        </div>
    );
}

/*
    Styles
 */

const sliderWrap = css`
    padding-bottom: ${parseFloat(arrowWrapperSize) + 4 * 0.8}rem;
`;

const slickArrowNext = css`
    right: 50%;
    transform: translate(100%, 100%);
`;

const slickArrowPrev = css`
    left: 50%;
    transform: translate(-100%, 100%);
`;

const adaptiveHeightByAllVisibleStyle = css`
    .slick-slide {
        height: 100px;
    }
    .slick-slide.slick-active {
        height: auto;
    }
`;

const adaptiveHeightIncludingInvisibleStyle = css`
    .slick-track {
        display: flex;
        align-items: stretch;
        position: relative;
    }

    .slick-slide {
        float: none;
        height: auto;
    }

    .slick-slide > * {
        height: 100%;
    }
`;
